export default __webpack_public_path__ + "static/media/appStore.61d2dea8.png";